import { render, staticRenderFns } from "./SaleStatTab.vue?vue&type=template&id=1961e9a6&scoped=true&"
import script from "./SaleStatTab.vue?vue&type=script&lang=js&"
export * from "./SaleStatTab.vue?vue&type=script&lang=js&"
import style0 from "./SaleStatTab.vue?vue&type=style&index=0&id=1961e9a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961e9a6",
  null
  
)

export default component.exports